import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, useSite, mediaUrl } from "@/lib/site";
import { Fld, BiText, UploadBtn, ImageList } from "./ui";

const TEXTS = [
  ["heroEyebrow", "Úvod – horný riadok"], ["slogan", "Slogan"], ["lifestyleTitle1", "Sekcia životný štýl – nadpis 1"], ["lifestyleTitle2", "Sekcia životný štýl – nadpis 2"],
  ["lifestyleText", "Sekcia životný štýl – text", true], ["destTitle", "Destinácie – nadpis"], ["ctaTitle", "Kontakt na hlavnej – nadpis"], ["ctaText", "Kontakt na hlavnej – text", true],
  ["aboutTitle", "O nás – nadpis"], ["aboutText", "O nás – text", true], ["partnerTitle", "Spolupráca – nadpis"], ["partnerText", "Spolupráca – text", true],
];
const IMAGES = [["lifestyle_image", "Životný štýl – pozadie", "/img/yacht.jpg"], ["split_image", "Životný štýl – fotka vpravo", "/img/p1.jpg"], ["cta_image", "Kontakt – pozadie", "/img/sail.jpg"], ["about_image", "O nás – hlavná fotka", "/img/int1.jpg"], ["about_image2", "O nás – druhá fotka", "/img/santorini2.jpg"], ["partner_image", "Spolupráca – fotka", "/img/p2.jpg"]];

const OneImage = ({ label, value, fallback, onChange, k }) => (
  <div className="bg-white border border-sand/60 p-3">
    <div className="text-[10px] tracking-[0.2em] uppercase text-midnight/60 mb-2">{label}</div>
    <div className="relative aspect-video bg-sand/30 mb-2"><img src={mediaUrl(value) || fallback} alt="" className="w-full h-full object-cover" />
      {value && <button onClick={() => onChange("")} className="absolute top-1 right-1 bg-midnight/70 text-ivory p-1" title="Pôvodná fotka"><X size={12} /></button>}
    </div>
    <UploadBtn testid={`content-upload-${k}`} label="Zmeniť" onUploaded={onChange} />
  </div>
);

export const ContentAdmin = () => {
  const { reload } = useSite();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data || {})).catch(() => {}); }, []);
  if (!s) return null;
  const c = s.content || {};
  const setC = (k, v) => setS((o) => ({ ...o, content: { ...(o.content || {}), [k]: v } }));
  const setText = (k, v) => setC("texts", { ...(c.texts || {}), [k]: v });
  const save = async () => {
    try { await api.put("/admin/settings", s); toast.success("Uložené"); reload(); } catch { toast.error("Uloženie zlyhalo"); }
  };
  return (
    <div className="space-y-10 max-w-5xl" data-testid="admin-content">
      <div className="flex justify-between items-center">
        <h2 className="font-display text-3xl text-midnight">Obsah webu</h2>
        <button className="btn-gold" onClick={save} data-testid="content-save">Uložiť obsah</button>
      </div>
      <Fld label="Úvodné fotky (slider na hlavnej stránke, prázdne = pôvodné)">
        <div className="space-y-3"><ImageList images={c.hero_images || []} onChange={(v) => setC("hero_images", v)} />
          <UploadBtn multiple testid="content-upload-hero" label="Pridať úvodné fotky" onUploaded={(u) => setS((o) => ({ ...o, content: { ...(o.content || {}), hero_images: [...((o.content || {}).hero_images || []), u] } }))} /></div>
      </Fld>
      <Fld label="Úvodné video na pozadí (nahradí slider)">
        <div className="flex items-center gap-3">
          {c.hero_video && <><video src={mediaUrl(c.hero_video)} muted className="w-40 aspect-video object-cover bg-midnight" /><button onClick={() => setC("hero_video", "")} className="text-xs text-red-600">Odstrániť</button></>}
          <UploadBtn accept="video/*" testid="content-upload-hero-video" label="Nahrať video" onUploaded={(u) => setC("hero_video", u)} />
        </div>
      </Fld>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {IMAGES.map(([k, l, fb]) => <OneImage key={k} k={k} label={l} value={c[k]} fallback={fb} onChange={(v) => setC(k, v)} />)}
      </div>
      <div className="space-y-6">
        <p className="text-sm text-midnight/60">Texty – prázdne pole = pôvodný text webu.</p>
        {TEXTS.map(([k, l, area]) => <BiText key={k} label={l} area={area} rows={4} value={c.texts?.[k]} onChange={(v) => setText(k, v)} testid={`content-${k}`} />)}
      </div>
      <button className="btn-gold" onClick={save} data-testid="content-save-bottom">Uložiť obsah</button>
    </div>
  );
};
